/**
 * Défini la ronde active
 * @type {string}
 */
export const SERVICE_ROUND_SET_ACTIVE = 'setRoundActive'
